$(function () {
  $(document).on('change', '.jsReservationExaminations', function () {
    var value = $(this).val();
    var serviceUrl = $(this).data('service') + "&isNewPatient=" + value;
    console.log(serviceUrl);
    $.get(serviceUrl, function (data) {
      console.log(data);
      var $select = $("#examinationId");
      $select.empty();
      $.each(data, function (index, examination) {
        // Use the Option() constructor to create a new HTMLOptionElement.
        var option = new Option(examination.Name, examination.Id);
        // Convert the HTMLOptionElement into a JQuery object that can be used with the append method.
        $(option).html(examination.Name);
        // Append the option to our Select element.
        $select.append(option);
      });
      $select.removeClass("d-none");
    });
  });

  $(document).on('change', '.VisitOption', function () {
    console.log('Visit option Change');
    if ($(this).val() === 'True') {
      $('.VisitOptionConfirm').addClass("d-none");
    } else {
      $('.VisitOptionConfirm').removeClass("d-none");
    }
  });

  $(document).on('change', '.jsReservationForm', function () {
    const $submitButton = $(this).find('button[type=submit]');
    const $radioMonth = $('input[name="StepMonth.Day"]');
    const $radioDay = $('input[name="StepDay.Ticks"]');
    if ($radioMonth.length > 0 && $radioMonth.is(':checked')) {
      $submitButton.removeAttr('disabled');
    }
    if ($radioDay.length > 0 && $radioDay.is(':checked')) {
      $submitButton.removeAttr('disabled');
    }
  });

  $(document).on('click', '.jsReserveSendActivationEmail', function (event) {
    var $button = $(this);
    var email = $button.data('email');
    $button.hide();
    $.get('/Reservation/SendActivationEmail?email=' + email, function (data) {
      console.log(data);
      var $span = $('.jsReserveSendActivationEmailMessage');
      if (data.IsSend == true) {
        $span.show().html(data.Message);
      } else {
        $span.show().html(data.Message);
        $button.show();
      }
    });
    event.preventDefault();
  });

  $('.jsReserveSendActivationEmailMessage').hide();

  $(document).on("click", "form.jsReservationForm :submit", function (e) {
    const $button = $(this);
    $button.attr("data-selected", "1");
  });

  $(document).on("submit", "form.jsReservationForm", function (e) {
    const $form = $(this);
    const $button = $(":submit[data-selected]", $form);
    const $target = $form.closest(".jsReservationFormTarget");
    const action = $form.attr("action");

    var parameters = $form.serialize()

    if (parameters.length > 0) {
      parameters = parameters + "&";
    }

    parameters = parameters + "IsAjax=true";

    var buttonName = $button.attr("name");
    var buttonValue = $button.attr("value");

    if (buttonName && buttonValue) {
      parameters = parameters + "&" + buttonName + "=" + buttonValue;
    }

    $button.removeAttr("data-selected");

    EUCUtils.reloadPost(action, $target, parameters, function () {
      var loginLink = $('.jsSSOCheckLogin');
      if (loginLink.length) {
        var startUrl = $('.jsLoginReplace').data('login-url');
        if (startUrl !== undefined) {
          var currentUrl = loginLink.attr('href');
          loginLink.attr('href', EUCUtils.replaceUrlParam(currentUrl, 'startUrl', startUrl));
        }
      }
      var historyHref = $('.jsLoginReplace').data('href-url');
      if (historyHref !== undefined) {
        history.pushState(null, null, historyHref);
      }

    });
    e.preventDefault();
  });
});
